import { deleteField, doc, UpdateData, updateDoc } from "firebase/firestore";
import Failure from "../../../core/Failure";
import { firestore } from "../../../firebase.config";
import { ECreditType, UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';
import { IPlan } from "@leedpulse-monorepo/interfaces";
import { FIREBASE_COLLECTIONS } from "@leedpulse-monorepo/consts";

async function updatePlan(
  id: string,
  planDoc: IPlan,
  auth: Authentication,
  opts: { clearedCredits?: ECreditType[]; clearedPayg?: ECreditType[] } = {}
): Promise<void> {
  if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
    throw new UpdatePlanFailure("Unauthorized", "unauthorized");
  }
  try {

    if (id === '' || planDoc.name === '' || planDoc.color === '' || planDoc.credits === null || planDoc.features === null || planDoc.price === null || planDoc.product === null || planDoc.recurrence === null || planDoc.recurrence_credits_reset === null) {
      throw new UpdatePlanFailure('Les informations renseignées sont incomplètes');
    }

    const planDocPatch: Record<string, unknown> = {
      name: planDoc.name,
      features: planDoc.features,
      price: planDoc.price,
      product: planDoc.product,
      recurrence: planDoc.recurrence,
      recurrence_credits_reset: planDoc.recurrence_credits_reset,
      links: planDoc.links,
      active: planDoc.active,
      archived: planDoc.archived ?? false,
      color: planDoc.color,
      downgradable_to: planDoc.downgradable_to ?? [],
      upgradable_to: planDoc.upgradable_to ?? [],
      partner_systems: planDoc.partner_systems ?? [],
      leedbucks_rates: planDoc.leedbucks_rates ?? {}, // whole map, so a removed row is removed from the plan too
      leedbucks_rates_temp: planDoc.leedbucks_rates_temp ?? [],
      starting_period: planDoc.starting_period ?? deleteField(),
      no_commitment: planDoc.no_commitment ?? false,
    }; // Don't forget to add wanted props for update to firebase here

    // credits types can be cleared from a plan
    for (const [k, v] of Object.entries(planDoc.credits ?? {})) planDocPatch[`credits.${k}`] = v;
    for (const k of (opts.clearedCredits ?? [])) planDocPatch[`credits.${k}`] = deleteField();
    for (const [k, v] of Object.entries(planDoc.payg ?? {})) planDocPatch[`payg.${k}`] = v;
    for (const k of (opts.clearedPayg ?? [])) planDocPatch[`payg.${k}`] = deleteField();

    const db = firestore;

    if(auth.role === UserRole.owner) console.log("Updating plan: ", id, planDocPatch); // For next debug from prod

    await updateDoc(
      doc(db, FIREBASE_COLLECTIONS.PLANS, id),
      planDocPatch as UpdateData<IPlan>
    );

    return;
  } catch (e) {
    console.log("error: ", e);
    throw new UpdatePlanFailure();
  }
}

export class UpdatePlanFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default updatePlan;
